<template>
  <div id="main" class="index">
    <topNav></topNav>
    <div class="demobox banner">
      <el-carousel trigger="click" class="bannerMain" v-show="banners.length>1">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="bannerimg">
            <img :src="item" class="bannerimg" alt="" />
            <a v-if="index === 0" href="https://www.dexunzhenggu.cn/h5/pdf/index.html" target="_blank"></a>
            <!-- <a v-if="index === 0" href="http://localhost:2020/" target="_blank"></a> -->
            <a v-if="index === banners.length - 1" href="https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1" target="_blank"></a>
            <!-- <img :src="item.imgSrc" class="bannerimg" alt="" />
            <a v-if="item.to" :href="item.url" target="_blank"></a> -->
          </div>
        </el-carousel-item>
      </el-carousel>
      <img v-show="banners.length<=1" :src="banners[0]" class="bannerimg" alt="" />
    </div>
    <div class="demobox licons">
      <div class="licons-boxin">
        <div class="liconin">
          <div class="cons">
            <img src="@/common/images/index/cons1.png" alt="" />
            <div>
              <p class="p1">资讯金融</p>
              <p class="p2">权威的财经资讯移动平台</p>
            </div>
          </div>
          <div class="line"></div>
          <div class="cons">
            <img src="@/common/images/index/cons2.png" alt="" />
            <div>
              <p class="p1">数据金融</p>
              <p class="p2">高度整合实时行情数据</p>
            </div>
          </div>
          <div class="line"></div>
          <div class="cons">
            <img src="@/common/images/index/cons3.png" alt="" />
            <div>
              <p class="p1">教育金融</p>
              <p class="p2">专业轻松的投资学习平台</p>
            </div>
          </div>
          <div class="line"></div>
          <div class="cons">
            <img src="@/common/images/index/cons4.png" alt="" />
            <div>
              <p class="p1">投顾金融</p>
              <p class="p2">多维度投顾服务管理系统</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="xian"></div>
    <div class="demobox info">
      <div class="boxin all">
        <div class="title">
          <div class="title-t">
            <!-- <img src="@/common/images/productCenter/A1/l1822.png" alt="" /> -->
            <!-- <span>实时资讯</span> -->
            <!-- <img src="@/common/images/productCenter/A1/l1823.png" alt="" /> -->
            <span>资讯中心</span>
          </div>
        </div>
        <div class="infoMain">
          <div
            class="infoMain-box"
            v-for="item in infolist2"
            :key="item.id"
            @click="toDetail(item, 'informatDetail')"
          >
            <img :src="item.img" alt="" />
            <div class="infoMain-font">
              <div class="infoMain-title">{{ item.title }}</div>
              <div class="infoMain-brief">{{ item.brief }}</div>
              <div class="infoMain-foot">
                <div>财富在线</div>
                <div>
                  <img src="@/common/images/index/rl2.png" alt="" />
                  <span style="margin-top: 3px">{{ item.published }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="infoMain-l">
            <div class="infoT">
              <b></b>
              <p>{{ cateList[0].name }}</p>
            </div>
            <div
              @click="toDetail(item, 'informatDetail')"
              class="infoM"
              v-for="(item, index) in infolist1"
              :key="index"
            >
              <div
                class="infoBox"
                :style="'background: url(' + item.img + ');'"
              >
                <div class="timebox">
                  <img src="@/common/images/index/rl1.png" alt="" />
                  <span>发布{{ item.published }}</span>
                </div>
              </div>
              <div class="infort">
                <div class="p1">{{ item.title }}</div>
                <div class="p2">{{ item.brief }}</div>
              </div>
            </div>
          </div> -->
          <!-- <div class="infoMain-r">
            <div class="infoT">
              <b></b>
              <p>{{ cateList[1].name }}</p>
            </div>
            <div class="infoMr">
              <div
                @click="toDetail(item, 'informatDetail')"
                class="infoMrm"
                v-for="(item, index) in infolist2"
                :key="index"
              >
                <img :src="item.img" class="infoMrimg" alt="" />
                <div class="pr">
                  <div class="pr1">{{ item.title }}</div>
                  <div class="pr2">
                    <img src="@/common/images/index/rl2.png" alt="" />
                    <span>发布{{ item.published }}</span>
                  </div>
                </div>
              </div> -->
          <!-- <div class="infoMrm">
                <img :src="info.info3.img" class="infoMrimg" alt="" />
                <div class="pr">
                  <div class="pr1">{{ info.info3.title }}</div>
                  <div class="pr2">
                    <img src="@/common/images/index/rl2.png" alt="" />
                    <span>发布{{ info.info3.time }}</span>
                  </div>
                </div>
              </div>
              <div class="infoMrm">
                <img :src="info.info4.img" class="infoMrimg" alt="" />
                <div class="pr">
                  <div class="pr1">{{ info.info4.title }}</div>
                  <div class="pr2">
                    <img src="@/common/images/index/rl2.png" alt="" />
                    <span>发布{{ info.info4.time }}</span>
                  </div>
                </div>
              </div> -->
          <!-- </div>
          </div> -->
        </div>
        <div class="infoButton" style="margin-top: 28px">
          <div
            @click="topath('information')"
            class="toinfoDetail btnBefore btn"
            v-if="!buttons.b1"
          >
            <p class="zwtz" @mouseenter="buttons.b1 = true"></p>
            <span>查看更多</span>
            <img src="@/common/images/index/back1.png" alt="" />
          </div>
          <div
            @click="topath('information')"
            class="toinfoDetail btnAfter btn"
            v-if="buttons.b1"
          >
            <p class="zwtz" @mouseout="buttons.b1 = false"></p>
            <span>查看更多</span>
            <img src="@/common/images/index/back2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="demobox product">
      <div class="boxin all chanping" style="width: 100%">
        <!-- <div class="title">
          <div class="title-t">
            <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
            <span>产品中心</span>
            <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
          </div>
        </div>
        <div class="products">
          <img src="@/common/images/index/prdu1.png" alt="" />
          <img src="@/common/images/index/prdu2.png" alt="" />
          <img src="@/common/images/index/prdu3.png" alt="" />
        </div>
        <div>
          <div class="productT">
            <b></b>
            <p>资讯产品</p>
          </div>
          <div class="productM">
            为用户提供股市资讯信息、研究策略报告、投资者教育服务的电子资讯工具，在全面行情、实时资讯服务以及深度智能应用的基础上，深度解决用户在金融投资各场景中的需求及痛点。
          </div>
          <div class="productButton" @click="topath('productCenter')">
            <div class="toproductDetail">
              <span>了解产品</span>
              <img src="@/common/images/index/back2.png" alt="" />
            </div>
          </div>
        </div> -->
        <img
          src="@/common/images/index/ProductCenter.png"
          alt=""
          class="productCenter"
        />
        <!-- <div class="wenziBox">
          <div class="wz">
            <span class="wzfixe">></span>
            <span class="wzfixe2" @click="tiaozhaung('ddzb')">大德周报</span>
          </div>
          <div class="wz">
            <span class="wzfixe">></span>
            <span class="wzfixe2" @click="tiaozhaung('ztcl')">主题策略</span>
          </div>
          <div class="wz">
            <span class="wzfixe">></span>
            <span class="wzfixe2">时报德宝</span>
          </div>
        </div> -->
        <div class="wenziBox">
          <div class="wz">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('大德火箭周报')">大德火箭周报</span>
          </div>
          <div class="wz">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('主题策略')">主题策略</span>
          </div>
          <!-- <div class="wz">
            <span class="">></span>
            <span class="wzfixe2">时报德宝</span>
          </div> -->
        </div>
        <!-- <div class="wenziBox wenziBox2">
          <div class="wz" style="margin-right: 27px">
            <span class="wzfixe fixewz" >></span>
            <span class="wzfixe2">股宇宙数据库</span>
          </div>
          <div class="wz" style="margin-right: 27px">
            <span class="wzfixe">></span>
            <span class="wzfixe2" @click="tiaozhaung('dxsf')">德讯算法</span>
          </div>
          <div class="wz" style="margin-right: 27px">
            <span class="wzfixe">></span>
            <span class="wzfixe2" @click="tiaozhaung('dxzg')">德讯证顾</span>
          </div>
        </div> -->
        <div class="wenziBox wenziBox2">
          <div class="wz" style="margin-right: ">
            <span class="" >></span>
            <span class="wzfixe2" @click="tiaozhaung('stockUniverse')">股宇宙数据库</span>
          </div>
          <div class="wz" style="margin-right: ">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('德讯算法')">德讯算法</span>
          </div>
          <div class="wz" style="margin-right: ">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('财富在线')">财富在线</span>
          </div>
        </div>
        <div class="wenziBox wenziBox3">
          <div class="wz">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('交易师')">交易师</span>
          </div>
          <!-- <div class="wz">
            <span class="">></span>
            <span class="wzfixe2">德财商学院</span>
          </div> -->
        </div>
        <div class="wenziBox wenziBox4">
          <div class="wz">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('大德精研')">大德精研</span>
          </div>
          <div class="wz">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('大德专属')">大德专属</span>
          </div>
          <div class="wz">
            <span class="">></span>
            <span class="wzfixe2" @click="tiaozhaung('诊股大师')">诊股大师</span>
          </div>
        </div>
      </div>
    </div>
    <div class="demobox investment">
      <div class="all">
        <div class="title">
          <div class="title-t">
            <!-- <img src="@/common/images/productCenter/A1/l1822.png" alt="" /> -->
            <span>投研中心</span>
            <!-- <img src="@/common/images/productCenter/A1/l1823.png" alt="" /> -->
          </div>
        </div>
        <!-- <img
          src="@/common/images/index/toucai.png"
          class="investmentBanner"
          alt=""
        /> -->
      <el-carousel trigger="click" class="bannerMain2" v-show="banners2.length>1">
        <el-carousel-item v-for="(item,index) in banners2" :key="index">
          <div class="investmentBanner">
            <img :src="item" class="investmentBanner" alt="" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <img :src="banners2[0]" v-show="banners2.length<=1" class="investmentBanner" alt="" />
        <div class="investmentText">
          <div class="p">
            财富在线汇聚业内顶尖人才,拥有经验丰富的互联网“大数据研发团队”。现有持牌投资顾问50余人,超20人的资深投顾投研团队,秉持以客户为中心,专业、诚信的原则,持续优化研究能力,为广大投资者提供公正、独立客观的全方位金融服务。
          </div>
          <div
            @click="topath('investTeam')"
            class="toinvestmentDetail btnBefore btn"
            v-if="!buttons.b3"
          >
            <p class="zwtz" @mouseenter="buttons.b3 = true"></p>
            <span>查看团队</span>
            <img src="@/common/images/index/back1.png" alt="" />
          </div>
          <div
            @click="topath('investTeam')"
            class="toinvestmentDetail btnAfter btn"
            v-if="buttons.b3"
          >
            <p class="zwtz" @mouseout="buttons.b3 = false"></p>
            <span>查看团队</span>
            <img src="@/common/images/index/back2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="demobox party">
      <div class="boxin all">
        <div class="title">
          <div class="title-t"> -->
            <!-- <img src="@/common/images/productCenter/A1/l1822.png" alt="" /> -->
            <!-- <span>党建专栏</span> -->
            <!-- <img src="@/common/images/productCenter/A1/l1823.png" alt="" /> -->
          <!-- </div>
        </div> -->
        <!-- <div
          @click="toDetail(item)"
          v-for="(item, index) in partys"
          :key="index"
          :class="item.class0 + ' ' + item.class1"
        >
          <div class="imgbox" :style="'background:url(' + item.img + ')'">
            <div class="time">发布{{ item.published }}</div>
          </div>
          <div class="partyte">
            <div class="ptitle">{{ item.title }}</div>
            <div class="ptext">{{ item.brief }}</div>
          </div>
        </div> -->
        <!-- <div
          class="infoMain-box"
          v-for="item in partys"
          :key="item.id"
          @click="toDetail(item)"
        >
          <img :src="item.img" alt="" />
          <div class="infoMain-font">
            <div class="infoMain-title">{{ item.title }}</div>
            <div class="infoMain-brief">{{ item.brief }}</div>
            <div class="infoMain-foot">
              <div>德讯证顾</div>
              <div>
                <img src="@/common/images/index/rl2.png" alt="" />
                <span>{{ item.published }}</span>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="partymin party2">
          <div
            class="imgbox"
            :style="'background:url(' + party.info2.img + ')'"
          >
            <div class="time">发布{{ party.info2.time }}</div>
          </div>
          <div class="ptitle">{{ party.info2.title }}</div>
        </div>
        <div class="partymin party3">
          <div
            class="imgbox"
            :style="'background:url(' + party.info3.img + ')'"
          >
            <div class="time">发布{{ party.info3.time }}</div>
          </div>
          <div class="ptitle">{{ party.info3.title }}</div>
        </div> -->
        <!-- <div class="btnOut">
          <div
            @click="topath('about?index=4')"
            class="toPartyDetail btnBefore btn"
            v-if="!buttons.b4"
          >
            <p class="zwtz" @mouseenter="buttons.b4 = true"></p>
            <span>查看更多</span>
            <img src="@/common/images/index/back1.png" alt="" />
          </div>
          <div
            @click="topath('about?index=4')"
            class="toPartyDetail btnAfter btn"
            v-if="buttons.b4"
          >
            <p class="zwtz" @mouseout="buttons.b4 = false"></p>
            <span>查看更多</span>
            <img src="@/common/images/index/back2.png" alt="" />
          </div>
        </div>
      </div>
    </div> -->
    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
import { colunmList,productList,columnTypeList } from "@/api/topNav.js";
import { l } from "@/utils/tool";
export default {
  name: "index",
  components: { topNav, Bottoms },
  data() {
    return {
      info: {
        info1: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "三大指数走势分化  东数西算再度井喷",
          text: "指数今日有所分化，主板指数震荡回升，创业板指弱势震荡。盘面上，题材板块轮番活跃。“东数西算”概念股继续强势，板块再掀涨停潮，依米康、首都在线、亚康股份、南凌科技等亚康股份、南凌科技等",
        },
        info2: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "【德讯早参】市场短期内有望迎来突破性大涨",
        },
        info3: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "【德讯早参】市场短期内有望迎来突破性大涨",
        },
        info4: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "【德讯早参】市场短期内有望迎来突破性大涨",
        },
      },
      party: {
        info1: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title: "同心抗疫 | 奉献社会爱心 助力抗击疫情",
          text: "献出一份爱心，收获无数温暖。临近年关，深圳再次拉响疫情防控警报，深圳各区紧急开展各项工作，为坚决抑制疫情蔓延势头，防止疫情外溢，全市各个街道社区开设核酸检测点，广大医务工作者和爱心支援者日夜奋战在一线，广大人民广大人民广大人民",
        },
        info2: {
          img: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title:
            "党史学习丨习近平：继续把党史总结学习教育宣传引向深入 更好把握和运用党的百年奋斗历更好把握和运用党的百年奋斗历",
        },
        info3: {
          img: "https://dexun-www-newsoss-cn-shenzhen.aliyuncs.com/zwt.png",
          time: "2022-03-11",
          title:
            "党史学习丨习近平：继续把党史总结学习教育宣传引向深入 更好把握和运用党的百年奋斗历更好把握和运用党的百年奋斗历",
        },
      },
      cateList: [{}, {}],
      infolist1: [],
      infolist2: [],
      partys: [],
      banners: [
        // {
        //   imgSrc: "https://dexun-www.oss-cn-shenzhen.aliyuncs.com/yzsm.png",
        //   key: 1,
        //   to: true,
        //   // url: "https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1",
        //   url: "https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1",
        // },
        // {
        //   imgSrc: "https://dexun-www.oss-cn-shenzhen.aliyuncs.com/515.png",
        //   key: 2,
        //   to: false,
        //   url: "",
        // },
        // {
        //   imgSrc:
        //     "https://dexun-www.oss-cn-shenzhen.aliyuncs.com/znqbanner.jpg",
        //   key: 3,
        //   to: false,
        //   url: "",
        // },
      ],
      banners2:[],
      //按钮变幻
      buttons: {
        b1: false,
        b2: false,
        b3: false,
        b4: false,
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getInfo();
    this.selectf();
  },
  methods: {
    getInfo: function () {
      var that = this;
      //实时资讯
      this.$api.cate_list().then((res) => {
        if (res.code == 0) {
          res.data.list == null ? "" : (this.cateList = res.data.list);
          this.infolist1 = [];
          this.infolist2 = [];
          this.cateList.map(function (item, index) {
            that.$api.information_list(item.id).then((res1) => {
              if (res1.code == 0 && index == 0) {
                // console.log(item.id, res1.data);
                that.infolist1 = res1.data.list.slice(0, 1);
              }
              if (res1.code == 0 && index == 1) {
                console.log(res1.data.list,'ss');
                that.infolist2 = res1.data.list.slice(0, 3);
                console.log(that.infolist2,'pp');
              }
            });
          });
          // console.log(that.infolist1, that.infolist2);
        }
      });
      //党建专栏
      this.$api.party_list().then((res) => {
        if (res.code == 0) {
          res.data.list == null
            ? ""
            : (this.partys = res.data.list.slice(0, 3));
          this.partys.map(function (item, index) {
            if (index != 0) {
              item.class0 = "partymin";
            } else {
              item.class0 = "partymin";
            }
            item.class1 = "party" + (index + 4);
          });
          console.log(this.partys);
        }
      });
    },
    bufnc(ev) {
      var ev = ev || window.event;
      var target = ev.target || ev.srcElement;
      var boll = target.classList[1];
      var name = target.classList[2];
      //console.log(target.classList);
      console.log(ev);

      var tname = target.nodeName.toLowerCase();
      console.log(boll, name, tname);
      if (tname == "div" || tname == "span" || tname == "img") {
        if (boll == "ins") {
          this.buttons[name] = true;
        } else {
          this.buttons[name] = false;
        }
      }
      console.log(this.buttons[name], name);
    },
    topath(path) {
      this.$router.push(path);
    },
    toDetail(data, name) {
      if (name == undefined) {
        window.open(data.html);
      } else {
        // console.log(data);
        this.$router.push(name + "?id=" + data.id);
      }
    },
    tiaozhaung(item){
      if(item == 'stockUniverse'){
        this.$router.push(item);
      }else{
      this.$router.push({
          path: '/ddzb',
          query: {
            name: item,
          },
        });
      }

      // this.$router.push(item);
    },
    selectf(){
        colunmList({ column_name:'首页' }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200 && res.data.list) {
          this.banners = res.data.list[0].pictures.split(',');
        }
      });
        colunmList({ column_name:'投研中心' }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200 && res.data.list) {
          this.banners2 = res.data.list[0].pictures.split(',');
        }
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .index {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(100%);
}
 */

/* body * {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  filter: gray;
} 
.topNav {
  top: -90px !important;
}*/
.index{
  overflow: hidden;
}
.bannerMain2 >>> .el-carousel__container {
  width: 100%;
  height: 580px !important;
}
.chanping {
  width: 1920px !important;
  height: 742px !important;
  position: relative;
}
.wenziBox {
  position: absolute;
  top: 0;
  color: #ff4b4f;
  font-size: 14px;
  font-family: PingFang SC-Heavy;
  display: flex;
  top: 62%;
  left: 18%;
  z-index: 10;
}
.fixewz{
  left: -14% !important;
}
.wenziBox2 {
  top: 86% !important;
  left: 34% !important;
}
.wenziBox3 {
  top: 85% !important;
  left: 51% !important;
}
.wenziBox4 {
  top: 62% !important;
  left: 68% !important;
}
.wz {
  position: relative;
  margin-right: 18px;
}
.wz:hover {
  cursor: pointer;
}
.wenziBox .wzfixe {
  position: absolute;
  /* top: 10%; */
  left: -18%;
}
.wenziBox .wzfixe2 {
  border-bottom: 1px solid #ff4b4f;
}
.all{
  width: 1920px;
  margin: auto;
}
.all .title {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 24px;
}
.all .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.all .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.all .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
/* -- */
.demobox {
  width: 100%;
  overflow: hidden;
}
.productCenter {
  display: block;
  width: 1920px;
  height: 742px;
  margin: 0 auto;
}
.boxin {
  width: 1226px;
  overflow: hidden;
  margin: 0 auto;
}
.xian {
  width: 1920px;
  margin: auto;
  height: 10px;
  background-color: #f4f4f4;
}
.banner {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 460px;
  margin: 0px auto;
  background: #ccc;
}
.bannerMain {
  width: 100%;
  height: 100%;
}

.bannerimg {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 460px;
  position: relative;
}
.bannerimg img {
  display: block;
  width: 1920px;
}
.bannerimg a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.licons-boxin {
  width: 1226px;
  margin: 0 auto;
}
.liconin {
  width: 1500px;
  height: 157px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.licons .cons {
  padding-right: 30px;
  overflow: hidden;
}
.licons .line {
  width: 30px;
  height: 59px;
  margin-top: 21px;
  opacity: 1;
  border-left: 1px solid #dbdbdb;
}

.licons .cons img {
  display: inline-block;
  margin-right: 20px;
  float: left;
}
.licons .cons div {
  float: left;
}
.licons .cons .p1 {
  height: 40px;
  font-size: 28px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
  text-align: left;
}
.licons .cons .p2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #505050;
  line-height: 22px;
  margin-top: 8px;
  text-align: left;
}
.info {
  /* height: 822px; */
  height: 865px;
  /* background: url("../common/images/index/jc.png"); */
}
.info .infoMain {
  width: 100%;
  /* display: flex; */
  justify-content: left;
}
.info .infoMain-l,
.info .infoMain-r {
  /* background: #505050;
  min-height: 100px;
  min-width: 200px; */
}
.info .infoMain-l {
  width: 576px;
  margin-right: 34px;
}
.infoMain-box {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.infoMain-box img {
  width: 344px;
  height: 194px;
}
.infoMain-box .infoMain-font {
  text-align: left;
  width: 577px;
  margin-left: 20px;
  position: relative;
}
.infoMain-box .infoMain-title {
  /* height: 37px; */
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  /* font-weight: bold; */
  color: #222222;
  /* line-height: 37px; */
  text-align: left;
  margin-bottom: 10px;
}
.infoMain-box .infoMain-brief {
  font-size: 18px;
  /* height: 140px; */
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.infoMain-box .infoMain-foot {
  display: flex;
  align-items: center;
  color: #666666;
  position: absolute;
  bottom: 0;
  font-size: 16px;
}
.infoMain-box .infoMain-foot div:nth-child(2) {
  display: flex;
  align-items: center;
  margin-left: 90px;
}
.infoMain-box .infoMain-foot img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.infoMain-box:hover .infoMain-title {
  color: #de161e;
  cursor: pointer;
}
.infoMain-box:hover {
  cursor: pointer;
}
.info .infoT {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
}
.info .infoT b {
  width: 4px;
  height: 20px;
  background: #e7413b;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.info .infoT p {
  height: 42px;
  font-size: 30px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin-left: 11px;
}

.info .infoM {
  width: 576px;
  margin-top: 12px;
}
.info .infoBox {
  width: 100%;
  height: 100%;
  height: 343px;
  border-radius: 4px;
  position: relative;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}
.info .infoM .timebox {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 205px;
  height: 46px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px 8px 0px 8px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.info .infoM .timebox img {
  margin: 0 8px 0 18px;
}
.info .infoM .timebox span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}
.info .infort .p1 {
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 37px;
  text-align: left;
  margin: 16px 0 12px 0;
}
.info .infort .p2 {
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.info .infort {
  cursor: pointer;
}
.info .infort:hover .p1 {
  color: #e7413b;
}
.info .infoMr {
  overflow: hidden;
  margin-top: 12px;
}
.infoMr .infoMrm {
  overflow: hidden;
  margin-bottom: 16px;
}
.infoMr .infoMrimg {
  display: block;
  float: left;
  width: 271px;
  height: 161px;
}
.infoMr .pr {
  width: 320px;
  height: 161px;
  float: left;
  margin-left: 16px;
  cursor: pointer;
}

.infoMr .pr .pr1 {
  height: 126px;
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333;
  line-height: 35px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.infoMr .pr .pr2 {
  height: 25px;
  display: flex;
  justify-content: left;
  align-items: center;
}
.infoMr .pr:hover .pr1 {
  color: #e7413b;
}
.infoMr .pr .pr2 img {
  margin-right: 10px;
}
.infoMr .pr .pr2 span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
}
.toinfoDetail {
  width: 172px;
  height: 48px;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  cursor: pointer;
  margin-top: 14px;
}
.toinfoDetail span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 25px;
}
.product {
  /* height: 575px; */
  overflow: hidden;
}
.product .title {
  margin-top: 60px;
  margin-bottom: 30px;
}
.products {
  width: 1279px;
  overflow: hidden;
  display: flex;
  justify-content: left;
  align-items: center;
  margin-left: -8px;
}

.product .productT {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
}
.product .productT b {
  width: 4px;
  height: 20px;
  background: #e7413b;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.product .productT p {
  height: 42px;
  font-size: 30px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  text-align: left;
  margin-left: 11px;
}
.productM {
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  margin-top: 10px;
  text-align: left;
}

.productButton {
  width: 172px;
  height: 48px;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  background: url("../common/images/index/button.png");
  cursor: pointer;
  margin-top: 14px;
}
.productButton span {
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}
.investment {
  overflow: hidden;
}
.investment .title {
  margin-top: 70px;
  margin-bottom: 30px;
}
.investmentBanner {
  display: block;
  width: 1920px;
  height: 580px;
  margin: 0 auto;
}
.investmentText {
  width: 1920px;
  margin: auto;
  height: 179px;
  overflow: hidden;
  background: #f4f4f4;
}
.investmentText .p {
  width: 1289px;
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  margin: 0 auto;
  margin-top: 10px;
  text-align: left;
}
.toinvestmentDetail {
  width: 172px;
  height: 48px;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  margin: 0 auto;
  margin-top: 16px;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.toinvestmentDetail span {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 25px;
}

.party {
  overflow: hidden;
  height: 887px;
}
.party .boxin {
  width: 1226px;
}
.party .title {
  margin-top: 60px;
  margin-bottom: 30px;
}
.party .party1 {
  width: 100%;
}
.party1 .imgbox {
  width: 100%;
  height: 560px;
  border-radius: 4px;
  position: relative;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}
.party1 .time {
  width: 199px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px 4px 0px 4px;
  position: absolute;
  left: 0;
  bottom: 0;
  line-height: 40px;
  text-align: center;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.party1 .ptitle {
  font-size: 28px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 40px;
  text-align: left;
  margin-top: 14px;
}
.party1 .ptext {
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 35px;
  text-align: left;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.ptext {
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 30px;
  text-align: left;
  margin-top: 4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.partymin {
  display: inline-block;
  width: 585px;
  float: left;
  margin-top: 5px;
  margin-bottom: 40px;
}
.party2 {
  margin-right: 18px;
}
.party3 {
  margin-left: 18px;
}
.party4 {
  margin-right: 56px;
}
.partymin .imgbox {
  width: 100%;
  height: 390px;
  border-radius: 4px;
  position: relative;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}
.partymin .time {
  width: 199px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 0px 4px 0px 4px;
  position: absolute;
  left: 0;
  bottom: 0;
  line-height: 40px;
  text-align: center;

  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
.partymin .ptitle {
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 33px;
  text-align: left;
  margin-top: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.toPartyDetail {
  width: 172px;
  height: 48px;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  margin: 0 auto;
  padding: 0 42px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.toPartyDetail span {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 25px;
}
.party .ptitle,
.party .partyte {
  cursor: pointer;
}

.party .partyte {
  text-align: left;
}
.party .ptitle:hover {
  color: #e7413b;
}
.party .partyte:hover .ptitle {
  color: #e7413b;
}

/*  */
.btn {
  position: relative;
}
.btn .zwtz {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.btnBefore {
  background: #fcfcfc;
  border: 1px solid #bbbbbb;
  border-radius: 6px 6px 6px 6px;
}
.btnBefore span {
  color: #999999;
}
.btnAfter {
  background: url("../common/images/index/button.png");
}
.btnAfter span {
  color: #ffffff;
}
.btnOut {
  width: 100%;
  overflow: hidden;
  margin: 28px auto;
}
</style>




// WEBPACK FOOTER //
// src/components/index.vue